async function addToCart() {
  console.log('Add to cart clicked');
  const quantity = document.getElementById('quantity').value;
  const variantId = document.querySelector('[name="id"]').value;
  console.log('Quantity:', quantity);
  console.log('Variant ID:', variantId);
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'items': [{
          'id': variantId,
          'quantity': parseInt(quantity)
        }]
      })
    });
    const data = await response.json();
    console.log('Cart response:', data);
    if (response.ok) {
      const cartDrawer = document.getElementById('site-cart');
      if (cartDrawer) {
        cartDrawer.classList.add('active');
        cartDrawer.style.display = 'block';
      }
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      console.log('Updated cart:', cart);
      const cartCount = document.querySelector('[data-cart-count]');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
      }
    }
  } catch (error) {
    console.error('Error:', error);
  }
}